/* jshint esversion: 6 */
const getters = {
  theme: (state) => state.app.theme,
  color: (state) => state.app.color,
  clientId: (state) => localStorage.getItem("clientId"),
  companyId: (state) =>
    state.user.company ? state.user.company.id : undefined,
  roles: (state) => state.user.roles,
  userInfo: (state) => state.user.userInfo,
  addRouters: (state) => state.permission.addRouters,
  dictMap: state => {
    const map = {}
    state.init.dictList.forEach(dict => {
      map[dict.alias] = dict.name
    })
    return map
  },
};

export default getters;
